var _set = require('lodash/set');
window.set = function(target, path, value) {
    if(typeof target === 'string') {
        value = path;
        path = target;
        target = window;
    }
    _set(target, path, value);
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 1
 ** module chunks = 0
 **/